import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define the API service for OREPacking
export const orePackingApi = createApi({
  reducerPath: 'orePackingApi',
  baseQuery: btBaseQuery,
  tagTypes: ['Packing'], // Define the tag type for cache management and invalidation
  endpoints: (builder) => ({
    // Define the endpoints for your API
    findAllPackings: builder.query({
      query: (company) => `packing/${company}`, // GET all packing entries by company
      providesTags: ['Packing'] // Cache with the 'Packing' tag
    }),
    findPendingPackings: builder.query({
      query: ({ cid, id }) => `packing/pend/${cid}/${id}`, // GET all pending packing entries by company
      providesTags: ['Packing'] // Cache with the 'Packing' tag
    }),
    findPackingById: builder.query({
      query: (id) => `packing/byid/${id}`, // GET packing entry by ID
      providesTags: ['Packing'] // Cache with the 'Packing' tag
    }),
    insertPacking: builder.mutation({
      query: (packing) => ({
        url: 'packing', // POST a new packing entry
        method: 'POST',
        body: packing
      }),
      invalidatesTags: ['Packing'] // Invalidate the 'Packing' tag cache
    }),
    updatePacking: builder.mutation({
      query: (packing) => ({
        url: 'packing', // PUT update packing entry
        method: 'PUT',
        body: packing
      }),
      invalidatesTags: ['Packing'] // Invalidate the 'Packing' tag cache
    }),
    deletePacking: builder.mutation({
      query: (id) => ({
        url: `packing/${id}`, // DELETE a packing entry by ID
        method: 'DELETE'
      }),
      invalidatesTags: ['Packing'] // Invalidate the 'Packing' tag cache
    })
  })
});

// Export the auto-generated hooks for the endpoints
export const {
  useFindAllPackingsQuery,
  useFindPendingPackingsQuery,
  useFindPackingByIdQuery,
  useInsertPackingMutation,
  useUpdatePackingMutation,
  useDeletePackingMutation
} = orePackingApi;
